import {MODALS_IDS} from '@Components/modal-container';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import type {MultipagePreviewThumbnailSelectionPanelProps} from '@Panels/multipage-preview-thumbnail-selection-panel/multipage-preview-thumbnail-selection-panel.types';
import {MULTIPAGE_PREVIEW_THUMBNAIL_SELECTION_PANEL_ID} from '@Panels/multipage-preview-thumbnail-selection-panel/multipage-preview-thumbnail-selection-panel.types';

export {MULTIPAGE_PREVIEW_THUMBNAIL_SELECTION_PANEL_ID};

export const openMultipagePreviewThumbnailSelectionModal = (props: MultipagePreviewThumbnailSelectionPanelProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.MULTIPAGE_PREVIEW_THUMBNAIL_SELECTION_MODAL,
      panelProps: {...props},
    })
  );
};
